import { IFetchResponse } from "interface/http";
import { useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { IArticleData } from "./Definitions/Article.d";
import { BLOG_API_BASE_URL } from '../../../constants';
import axios from "axios";
import { INITIAL_ARTICLE_DATA } from "./Data/Article";

type TResponse = IFetchResponse<IArticleData>;

interface IUseFetchArticleProps {
  slug: string;
  stopFetch?: boolean;
}

const INITIAL_DATA: IArticleData = INITIAL_ARTICLE_DATA;

export const useFetchArticle = (props: IUseFetchArticleProps) => {
  const {slug, stopFetch} = props;

  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [data, setData] = useState<IArticleData>(INITIAL_DATA);
  const [response, setResponse] = useState<TResponse>();

  useEffect(() => {
    if (stopFetch || !slug) {
      return;
    }

    const fetchUrl = `${BLOG_API_BASE_URL}/articles/${slug}`;

    setIsFetching(true);
    axios
      .get<TResponse>(fetchUrl)
      .then((res) => {
        const responseData = res.data.data;
        setTimeout(() => {
          setIsFetching(false);
        }, 1000)
        setIsError(false);
        setResponse(res.data);
        setData(responseData);
      })
      .catch((err) => {
        console.log('failed to fetch articles', err);

        setIsFetching(false);
        setIsError(true);
      });

    return () => {
      setIsError(false);
      setIsFetching(false);
      setData(INITIAL_DATA);
      setResponse(undefined);
    };
  }, [slug, stopFetch]);

  return {
    isFetching,
    isError,
    data,
    response
  };
}